let initialized = false;

export function initMetaPixel(pixelId) {
  if (!pixelId || initialized || typeof window === "undefined") return;
  initialized = true;

  const n = (window.fbq = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments);
    } else {
      n.queue.push(arguments);
    }
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function trackPurchase(eventId, value) {
  if (typeof window !== "undefined" && window.fbq && eventId) {
    window.fbq("track", "Purchase", { value, currency: "IDR" }, { eventID: eventId });
  }
}

export function getMetaCookies() {
  if (typeof document === "undefined") return { fbp: null, fbc: null };
  const read = (name) => {
    const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  };
  return { fbp: read("_fbp"), fbc: read("_fbc") };
}
